import { useTranslation } from 'next-i18next';
import { type QuizType } from '../../type';
import { QUIZ_TYPE_ICON_MAP } from './QuizTypeIcons';
export const QuizTypeSelectorOption = ({
  type
}: {
  type: QuizType;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <span className="flex items-center gap-3xs" data-sentry-component="QuizTypeSelectorOption" data-sentry-source-file="QuizTypeSelectorOption.tsx">
      {QUIZ_TYPE_ICON_MAP[type]}
      {t(`build.quizType.${type}`)}
    </span>;
};